export const Login = () => {
  return (
    <>
      <div className="breadcrumb-banner-area">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumb-text">
                <h1 className="text-center">Iniciar sesión</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-form-area section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-12">
              <h4 className="contact-title"></h4>
              <form id="contact-form" action="mail.php" method="post">
                <div className="row">
                  <div className="col-md-6">
                    <input type="text" name="name" placeholder="Usuario" />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="password"
                      name="apellidos"
                      placeholder="Contraseña"
                    />
                  </div>
                </div>
              </form>
              <p className="form-messege"></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
